import { FC } from 'react';

interface CalendarProps {}

const SearchIcon: FC<CalendarProps> = (props: CalendarProps) => {
    return (
        <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M12.9375 14L7.95833 9.02083C7.54167 9.32639 7.08478 9.56597 6.58767 9.73958C6.09056 9.91319 5.56158 10 5.00073 10C3.61135 10 2.43056 9.51389 1.45833 8.54167C0.486111 7.56944 0 6.38889 0 5C0 3.61111 0.486111 2.43056 1.45833 1.45833C2.43056 0.486111 3.61111 0 5 0C6.38889 0 7.56944 0.486111 8.54167 1.45833C9.51389 2.43056 10 3.61135 10 5.00073C10 5.56158 9.91319 6.09056 9.73958 6.58767C9.56597 7.08478 9.32639 7.54167 9.02083 7.95833L14 12.9375L12.9375 14ZM5 8.5C5.97222 8.5 6.79861 8.15972 7.47917 7.47917C8.15972 6.79861 8.5 5.97222 8.5 5C8.5 4.02778 8.15972 3.20139 7.47917 2.52083C6.79861 1.84028 5.97222 1.5 5 1.5C4.02778 1.5 3.20139 1.84028 2.52083 2.52083C1.84028 3.20139 1.5 4.02778 1.5 5C1.5 5.97222 1.84028 6.79861 2.52083 7.47917C3.20139 8.15972 4.02778 8.5 5 8.5Z'
                fill='#1C1B1F'
            />
        </svg>
    );
};

export default SearchIcon;
